import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

// firebase init
const config = {
    apiKey: "AIzaSyCJKzWVKVYYPJDUpJCzDB4ji_LDj_IrMos",
    authDomain: "syl-vain.firebaseapp.com",
    databaseURL: "https://syl-vain.firebaseio.com",
    projectId: "syl-vain",
    storageBucket: "syl-vain.appspot.com",
    messagingSenderId: "292390304192"
}

firebase.initializeApp(config)

export default firebase
